import Modal from '@preqin/ui-components/cjs/core/Modal';
import { CircleDash } from '@preqin/ui-components/cjs/icons/operations';

import { ModalProps } from './ModalProps';

export const ReportFilterUpdateModal = ({ isOpen, isLoading, handleSubmit, handleCancel }: ModalProps) => {
  return (
    <Modal
      headerTitle="Update Search"
      isOpen={isOpen}
      size="md"
      primaryButtonDisabled={isLoading}
      primaryButtonText={isLoading ? 'Saving' : 'Save changes'}
      secondaryButtonText="Don't save"
      primaryButtonLoading={isLoading}
      primaryButtonIconEnd={isLoading ? <CircleDash height={16} width={16} /> : null}
      handleOnModalToggleFunction={handleCancel}
      handleOnModalPrimaryButtonClick={() => handleSubmit()}
      handleOnModalSecondaryButtonClick={handleCancel}
      bodyContent={<p>Do you want to save the changes to your existing saved search?</p>}
    />
  );
};
